import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Form, Input, notification, Typography } from 'antd'
import useMutation from 'hooks/useMutation'
import { clearIdTokens, getToken } from 'services/authAxios'
import { LocalAuthStorageKey } from 'types'
import Validators from 'utils/validators'

import Button from 'components/atoms/Button'

import OverCountVerifyEmailModal from './over-count-verify-modal'

export default function SessionExpiredVerifyEmail() {
  const [verifyCount, setVerifyCount] = useState({
    count: 0,
    errorKey: ''
  })

  const { t } = useTranslation()

  const { trigger: triggerVerifyEmail, isMutating: isVerifyingEmail } =
    useMutation('/v1/auth/email/verify')
  /**
   * @description Handle verify email
   * @param values
   */
  const handleVerifyEmail = (values: any) => {
    setVerifyCount((prev) => ({
      ...prev,
      count: prev.count + 1
    }))

    triggerVerifyEmail(
      {
        data: {
          email: values.email,
          // use acessToken for get user info because refresh token can not get user info
          refreshToken: getToken().idToken
        }
      },
      {
        onSuccess: () => {
          // Pass email as URL parameter
          window.location.replace(
            `/session-expired-otp-verify?email=${encodeURIComponent(
              values.email
            )}`
          )
        },
        onError: (e: any) => {
          if (e.response?.data.error.key === 'error_verify_email_failed') {
            setVerifyCount((prev) => ({
              ...prev,
              errorKey: e.response.data.error.key
            }))
            notification.error({
              message: 'メールアドレスが一致しません。',
              description: e.response.data.error.description
            })
          }
        }
      }
    )
  }

  const handleBack = () => {
    localStorage.removeItem(LocalAuthStorageKey.PREVIOUS_SESSION_EXPIRED_PATH)
    clearIdTokens()
    localStorage.removeItem('last_activity')
    window.location.replace('/signin')
  }

  return (
    <>
      <div className="flex flex-col items-center justify-center min-h-screen p-4 pb-[78px]">
        <div className="w-full max-w-md p-8 bg-white rounded-2xl shadow-lg">
          <div className="text-center mb-[10px]">
            <Typography className="!mb-2 !text-xl text-[#3163B7] font-bold">
              {t('sessionExpired.otpVerify.title')}
            </Typography>
            <div className="h-[1px] w-[72px] bg-[#3163B7] mx-auto mb-[30px]" />
            <Typography.Text
              type="secondary"
              className="text-base font-[400] !text-[#021120]"
            >
              {t('sessionExpired.otpVerify.verifyDescription')}
            </Typography.Text>
          </div>

          <Form layout="vertical" onFinish={handleVerifyEmail}>
            <Form.Item
              name="email"
              rules={[{ validator: Validators.emailValidator(t) }]}
            >
              <Input
                size="large"
                placeholder={t('sessionExpired.otpVerify.emailPlaceholder')}
                className="rounded-lg"
                autoComplete="off"
              />
            </Form.Item>

            <div className="flex justify-center items-center gap-x-[10px]">
              <Button
                sizing="w-full h-[60px]"
                className="cancel-button"
                onClick={handleBack}
              >
                {t('sessionExpired.otpVerify.back')}
              </Button>

              <Button
                type="primary"
                sizing="w-full h-[60px]"
                htmlType="submit"
                loading={isVerifyingEmail}
              >
                {t('sessionExpired.otpVerify.verify')}
              </Button>
            </div>
          </Form>
        </div>
      </div>

      {verifyCount.count >= 5 &&
        verifyCount.errorKey === 'error_verify_email_failed' && (
          <OverCountVerifyEmailModal />
        )}
    </>
  )
}
